// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e1f7be47","732":"f6c29793","977":"85124de2"}[chunkId] + ".chunk.js";
};